// Gecombineerde weergavestatus voor de live schermen: het sessiestatus-veld
// (wachtend/actief/beeindigd/verlopen, van de server) samen met de lokale
// SSE-verbindingsstatus (useLiveSessionStream) tot één set duidelijke,
// Nederlandse toestanden voor de UI.
import type { LiveStreamStatus } from './hooks/useLiveSessionStream';
import type { PresentationSession } from './types';

export type LiveDisplayStatus =
  | 'wacht_op_koppeling'
  | 'gekoppeld'
  | 'verbroken'
  // Automatisch herstellen is opgegeven; de laatst bekende slide blijft staan
  // en de gebruiker kan handmatig opnieuw verbinden.
  | 'verbroken_gestopt'
  | 'verlopen'
  | 'beeindigd'
  | 'onherstelbaar';

export function computeLiveDisplayStatus(
  session: PresentationSession | null,
  streamStatus: LiveStreamStatus,
): LiveDisplayStatus {
  if (!session) return 'onherstelbaar';
  if (session.status === 'beeindigd') return 'beeindigd';
  if (session.status === 'verlopen') return 'verlopen';
  if (streamStatus === 'ended') return 'beeindigd'; // server: sessie beëindigd/verlopen tijdens onderbreking
  if (streamStatus === 'unrecoverable') return 'onherstelbaar';
  if (streamStatus === 'disconnected') return 'verbroken_gestopt';
  if (streamStatus === 'reconnecting') return 'verbroken';
  if (session.status === 'wachtend') return 'wacht_op_koppeling';
  return 'gekoppeld';
}

export const LIVE_DISPLAY_STATUS_LABELS: Record<LiveDisplayStatus, string> = {
  wacht_op_koppeling: 'Wacht op koppeling',
  gekoppeld: 'Verbonden',
  verbroken: 'Verbinding verbroken, opnieuw verbinden...',
  verbroken_gestopt: 'Verbinding verbroken, automatisch herstellen is gestopt',
  verlopen: 'Sessie verlopen',
  beeindigd: 'Sessie beëindigd',
  onherstelbaar: 'Onherstelbare fout',
};
